import MenuItemGroup from '../menu/src/menu-item-group';

MenuItemGroup.install = function(Vue) {
  Vue.component(MenuItemGroup.name, MenuItemGroup);
};

export default MenuItemGroup;



// WEBPACK FOOTER //
// ./src/components/menu-item-group/index.js